import React, { useEffect } from "react";
import {
  Grid,
  Box, Skeleton
} from "@mui/material";
import StyledSection from "../../../common/StyledSection";
import { ContainedButton, TextButton } from "../../../common/StyledButtons";
import { withRouter } from "react-router";
import { getSiteById } from "../../../../selectors/SiteSelectors";


const EndOfYearAccountingCard = ({ history, siteId }) => {

  const site = getSiteById(siteId);

  const renderResourcesCards = () => (
    <StyledSection
      title="Invoices"
      image="https://s3.us-east-2.amazonaws.com/docs.consultwithkyle.com/assets/eoy-accounting.webp"
    >
      <p>Your invoices, including your 2025 year-end records, are available anytime in one convenient place. Use the link below to view or download past and current invoices whenever you need them.</p>
      
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', marginTop: '40px'}}>
        <ContainedButton
          sx={{ padding: '8px 16px 8px 16px' }}
          onClick={() => history.push(`/dashboard/site/${siteId}/account/billing`)}
        >View Invoices</ContainedButton>
      </Box>
    </StyledSection>
  )

  if (site.site_external_connections.box) {
    return renderResourcesCards();
  }

  
}

export default withRouter(EndOfYearAccountingCard);
